import axios from "axios";
const { API_BACKEND_HOST } = process.env;
const responseFormat = { error: "", data: null };

export const getApprovalsByCommitteeSlotId = async ({ committeeSlotId }) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.get(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/approvers/${committeeSlotId}`,
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const addApprovals = async (payload) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.post(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/approvers`,
      payload
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};

export const removeVote = async (params) => {
  try {
    const languageId = localStorage.getItem("i18nextLng");

    const { data } = await axios.delete(
      `${API_BACKEND_HOST}${languageId}/v1/Ata/approver/${params.id}`,
    );

    return data;
  } catch ({ response }) {
    responseFormat.error = "async";

    return responseFormat;
  }
};
